
import "./RegistroEnviado.css";

const TerminosCondiciones = () => {
  return (
   <div className="p-6 space-y-6 text-justify text-sm leading-relaxed max-w-3xl mx-auto">
  <h2 className="text-base font-bold">I. Aceptación de las Condiciones</h2>
  <p>
    La aplicación móvil y/o web denominada{" "}
    <strong>“PASAPORTE HACIA EL EMPLEO”</strong> ha sido desarrollada y es
    gestionada por el <strong>Ayuntamiento de Isla Cristina</strong>, con
    domicilio en Avenida Gran Vía, 43, 21410 – Isla Cristina (Huelva). La mera
    utilización de esta aplicación implica la aceptación plena y sin reservas
    del presente Aviso Legal por parte del usuario. Los usuarios también quedan
    sometidos a cualquier otra condición específica, aviso o instrucción que se
    establezca en relación con los servicios concretos ofrecidos a través de la
    aplicación.
  </p>

  <h2 className="text-base font-bold">II. Objeto de la Aplicación</h2>
  <p>
    El uso de esta aplicación implica el tratamiento de datos personales con el
    fin de gestionar la participación en el proyecto{" "}
    <strong>
      “PASAPORTE HACIA EL EMPLEO – Mejorando la empleabilidad de las personas”
    </strong>
    . La aplicación facilita el acceso a servicios y funcionalidades como
    orientación laboral, registro de formación, citas con agentes sociales y
    herramientas de seguimiento de empleabilidad, como parte de una intervención
    pública de interés social.
  </p>
  <p>
    Este proyecto está cofinanciado por la{" "}
    <strong>Unión Europea</strong> a través del Mecanismo para la Recuperación y
    Resiliencia (MRR) dentro del Plan de Recuperación, Transformación y
    Resiliencia (PRTR). El proyecto es una iniciativa del Ayuntamiento de Isla
    Cristina, que es el responsable del tratamiento de los datos.
  </p>

  <h2 className="text-base font-bold">III. Uso de la Aplicación y Contenido</h2>
  <ul className="list-disc pl-6 space-y-2">
    <li>
      <strong>Uso autorizado:</strong> Se prohíbe el uso no autorizado de los
      contenidos, datos y recursos accesibles a través de la aplicación.
    </li>
    <li>
      <strong>Propiedad Intelectual:</strong> Todos los contenidos de la
      aplicación, incluidos textos, imágenes, diseños, interfaces, logotipos,
      códigos fuente, marcas o signos distintivos, están protegidos por derechos
      de propiedad intelectual e industrial y pertenecen al Ayuntamiento de Isla
      Cristina o a terceros que han autorizado su uso. El acceso a la aplicación
      no implica la cesión de ningún derecho sobre dichos contenidos.
    </li>
    <li>
      <strong>Restricciones:</strong> Salvo autorización previa y por escrito
      del Ayuntamiento de Isla Cristina, el usuario no podrá reproducir,
      distribuir, transformar, comunicar públicamente ni extraer, reutilizar o
      explotar la totalidad o parte del contenido de la aplicación más allá de
      lo permitido por la legislación vigente y para su uso personal.
    </li>
  </ul>

  <h2 className="text-base font-bold">IV. Exclusión de Responsabilidad</h2>
  <ul className="list-disc pl-6 space-y-2">
    <li>
      El Ayuntamiento de Isla Cristina no garantiza la disponibilidad,
      continuidad ni la fiabilidad del funcionamiento de la aplicación, sus
      servicios o contenidos.
    </li>
    <li>
      Cuando sea técnicamente posible, se advertirá previamente a los usuarios
      de las interrupciones.
    </li>
    <li>
      El Ayuntamiento no se responsabiliza de los daños o perjuicios derivados
      de la falta de disponibilidad o del mal funcionamiento de la aplicación o
      de cualquiera de sus funcionalidades.
    </li>
  </ul>

  <h2 className="text-base font-bold">V. Protección de Datos Personales</h2>
  <p>
    El uso de la aplicación implica el tratamiento de datos personales conforme
    al <strong>Reglamento (UE) 2016/679 (RGPD)</strong> y la{" "}
    <strong>Ley Orgánica 3/2018 (LOPDGDD)</strong>. La base legal para el
    tratamiento de los datos es el cumplimiento de una misión de interés
    público, así como el consentimiento del interesado cuando sea necesario.
  </p>
  <ul className="list-disc pl-6 space-y-2">
    <li>
      <strong>Datos recopilados:</strong> Se tratarán datos necesarios para el
      funcionamiento de la aplicación, tales como datos identificativos (nombre,
      apellidos, DNI/NIE), datos de contacto (correo electrónico, teléfono) y
      datos de empleabilidad (formación, experiencia laboral, etc.). No se
      recogen datos sensibles a menos que sean necesarios para el
      acompañamiento personalizado y con consentimiento explícito.
    </li>
    <li>
      <strong>Comunicación de datos:</strong> Sus datos podrán ser comunicados a
      entidades participantes en la Red de Empleo Local de Isla Cristina, a
      organismos financiadores (Junta de Andalucía, Ministerio de Derechos
      Sociales, Unión Europea) para fines de auditoría, justificación y
      evaluación, y a proveedores tecnológicos con los que se tenga un contrato
      de tratamiento de datos.
    </li>
    <li>
      <strong>Derechos del Usuario:</strong> Puede ejercer los derechos de
      acceso, rectificación, supresión, oposición, limitación y portabilidad de
      sus datos. Estos derechos pueden ser ejercidos mediante solicitud al
      Ayuntamiento de Isla Cristina. En caso de desacuerdo, puede presentar una
      reclamación ante la Agencia Española de Protección de Datos (AEPD).
    </li>
  </ul>

  <h2 className="text-base font-bold">VI. Ley Aplicable y Jurisdicción</h2>
  <p>
    Estos Términos y Condiciones se rigen por la legislación española. Para
    cualquier controversia derivada del uso de la aplicación, las partes se
    someten expresamente a los Juzgados y Tribunales de Huelva, con renuncia a
    su fuero propio.
  </p>
</div>

  );
};

export default TerminosCondiciones;